export default "__VITE_ASSET__9br8ypun__"